// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectLanguage_select__2gG8U"};